module.exports = __webpack_public_path__ + "6c08ac9dae732f5efb9e741e4bfa6cad.png";